import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import DirectForm from './direct-form';

const { UI } = Mobi2Go;

class OnlineMethod extends React.Component {
    static propTypes = {
        processor: PropTypes.string.isRequired,
        available_payment_processors: PropTypes.array.isRequired,
        card_tokens: PropTypes.array.isRequired,
        payment_method: PropTypes.string,
        payment_card_token: PropTypes.object,
        payment_processor: PropTypes.object,
        is_offline_available: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        location: PropTypes.object,
    };

    state = {
        is_dark: false,
    };

    componentDidMount = () => {
        this.detectBackgroundColour();
    };

    detectBackgroundColour = () => {
        if (!window.getComputedStyle || !this.element) {
            this.scheduleBackgroundColourDetection();
            return;
        }

        try {
            const is_dark = UI.helpers.isElementBackgroundDark(this.element);
            if (is_dark === null) {
                this.scheduleBackgroundColourDetection();
                return;
            }

            this.setState({
                is_dark,
            });
        } catch (e) {}
    };

    scheduleBackgroundColourDetection = () => {
        setTimeout(this.detectBackgroundColour, 500);
    };

    isMethodActive = () => {
        return (
            this.props.payment_method === 'online' &&
            !this.props.payment_card_token &&
            !!this.props.payment_processor &&
            this.props.payment_processor.name === this.props.processor
        );
    };

    onMethodClick = () => {
        if (this.isMethodActive()) {
            return;
        }
        this.props.onClick();
    };

    onMethodKeyDown = e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onMethodClick();
        }
    };

    render() {
        let processor = null;
        if (
            this.props.payment_processor &&
            this.props.payment_processor.name === this.props.processor
        ) {
            processor = this.props.payment_processor;
        } else {
            for (
                let i = 0;
                i < this.props.available_payment_processors.length;
                i++
            ) {
                const available_payment_processor = this.props
                    .available_payment_processors[i];
                if (available_payment_processor.name === this.props.processor) {
                    processor = available_payment_processor;
                    break;
                }
            }
        }
        if (processor === null) {
            return null;
        }
        return (
            <div
                data-method="online"
                data-non-tokenised
                data-processor={this.props.processor}
                className="m2g-order-confirmation-payment-method"
                data-checked={this.isMethodActive()}
                onClick={this.onMethodClick}
                ref={el => (this.element = el)}
            >
                {(this.props.is_offline_available ||
                    this.props.available_payment_processors.length > 1 ||
                    this.props.card_tokens.length > 0) && (
                    <span className="m2g-order-confirmation-payment-method-text">
                        <input
                            type="checkbox"
                            data-method="online"
                            data-non-tokenised
                            className="m2g-order-confirmation-payment-method-checkbox"
                            checked={this.isMethodActive()}
                            onChange={this.onMethodClick}
                            onKeyDown={this.onMethodKeyDown}
                        />

                        {processor.storefront_display_name === '' ? (
                            <Trans
                                i18nKey="order.confirmation:pay_now_cc"
                                count={this.props.card_tokens.length + 1}
                            >
                                <span>
                                    I will pay now with&nbsp;
                                    <strong>
                                        {this.props.card_tokens.length
                                            ? 'a new '
                                            : ''}{' '}
                                        Credit or Debit card&nbsp;
                                    </strong>
                                </span>
                            </Trans>
                        ) : (
                            <Trans
                                i18nKey="order.confirmation:pay_now_cc_custom"
                                values={{
                                    custom_name:
                                        processor.storefront_display_name,
                                }}
                            >
                                <span>
                                    I will pay now with&nbsp;
                                    <strong>
                                        {processor.storefront_display_name}
                                    </strong>
                                </span>
                            </Trans>
                        )}
                    </span>
                )}

                {processor.getFormType() === 'direct' &&
                    processor.getName() !== 'AdyenTerminal' &&
                    processor.getName() !== 'SquareTerminal' &&
                    processor.getName() !== 'WindcaveTerminal' &&
                    processor.getName() !== 'Mobi2GoApplePay' &&
                    processor.getName() !== 'Mobi2GoGooglePay' && (
                        <DirectForm
                            online_only={!this.props.is_offline_available}
                            location={this.props.location}
                            payment_processor={processor}
                        />
                    )}

                <div
                    className="m2g-order-confirmation-payment-processor-logo m2g-payment-processor-logo"
                    data-processor={this.props.processor}
                    data-processor-logo
                >
                    <img
                        src={processor.getLogoUrl(this.state.is_dark)}
                        alt={`${this.props.processor} Logo`}
                    />
                </div>
            </div>
        );
    }
}

export default OnlineMethod;
